// @flow

import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import FantasyLabsService from './services/fantasyLabsService';
import { Layout } from 'component-library';
import Main from './components/Main/Main';
import { getAllSports } from './redux/actions/sports';
import { logoutUser } from './redux/actions/logout';
import environment from './config/environment';

// header

type Props = {
    cookies: { [key: string]: any },
    sports: { [key: string]: any },
    baseUrl: string,
    getAllSports: Function,
    logoutUser: Function
};

type State = {
    loginCookie: string,
    isSportsInsights: boolean
};

const baseUrl = environment.fantasyLabsUrl;

class App extends Component<Props, State> {
    fantasyLabsService = new FantasyLabsService();

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    componentWillMount() {
        const { cookies } = this.props;
        this.setState({
            loginCookie: cookies.get('flid') || this.fantasyLabsService.getSISessionToken() || '0',
            isSportsInsights: this.fantasyLabsService.isSportsInsights()
        });
    }

    componentDidMount() {
        this.props.getAllSports(this.state.loginCookie);
    }

    handleLogout = () => {
        const { cookies } = this.props;
        cookies.remove('flid', { path: '/' });
        this.props.logoutUser(this.state.loginCookie);
        document.location.href = this.props.baseUrl + '/account/login/';
    };

    render() {
        let routes = '';
        const hostname = window && window.location && window.location.hostname;
        if (
            this.state.isSportsInsights &&
            this.state.loginCookie === '0' &&
            hostname.indexOf('qa') === -1 &&
            hostname.indexOf('localhost') === -1
        ) {
            document.location.href = environment.sportsInsightsBaseUrl + '/login';
        } else if (
            this.state.loginCookie === 0 &&
            hostname.indexOf('qa') === -1 &&
            hostname.indexOf('localhost') === -1
        ) {
            document.location.href = baseUrl + '/pricing/upgrade-lite/';
        } else {
            routes = (
                <Switch>
                    <Route path="/apps/propositions/:sport/:start_date/:end_date/" component={Main} />
                    <Route path="/apps/propositions/:sport" component={Main} />
                    <Redirect to="/apps/propositions/nfl" />
                </Switch>
            );
        }

        return (
            <Layout
                hideHeader={this.fantasyLabsService.isSportsInsights()}
                loginCookie={this.state.loginCookie}
                baseUrl={baseUrl}
                sports={this.props.sports}
                handleLogout={this.handleLogout}
            >
                {routes}
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        sports: state.sports.results
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAllSports: sessionId => dispatch(getAllSports(sessionId)),
        logoutUser: sessionId => dispatch(logoutUser(sessionId))
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withCookies(App))
);



// WEBPACK FOOTER //
// ./src/App.js